import { render, staticRenderFns } from "./dataDictionary.vue?vue&type=template&id=b229e072&scoped=true"
import script from "./dataDictionary.vue?vue&type=script&lang=js"
export * from "./dataDictionary.vue?vue&type=script&lang=js"
import style0 from "./dataDictionary.vue?vue&type=style&index=0&id=b229e072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b229e072",
  null
  
)

export default component.exports